<!--
 * @Author: tony.zhu
 * @Date: 2023-12-01 11:10:44
 * @LastEditTime: 2025-09-02 14:01:30
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <el-tooltip :placement="placement" v-bind="$attrs" :popper-class="`custom_popper_class ${$attrs.popperClass !== undefined ? $attrs.popperClass : ''}`" :disabled="isShowTooltip">
    <div slot="content">
      <span v-html="data[keyName] || customStr"></span>
    </div>
    <div
      class="overflow"
      @mouseover="
        onIsShowTooltipByMouseOver(`${classStr}_${data.id || customId}`)
      "
    >
      <span
        :id="`${classStr}_${data.id || customId}`"
        v-html="data[keyName] || customStr"
      ></span>
    </div>
  </el-tooltip>
</template>

<script>
import { commonMixinByTooltip } from "@/components/aiChat/common/commonMixinByTooltip.js";
import tool from '@/components/aiChat/utils/tbox.js'
export default {
  name: "Tooltip",
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    keyName: {
      type: String,
      default: "",
    },
    placement: {
      type: String,
      default: "top",
    },
    customStr: {
      type: [String, Number],
      default: "",
    },
  },
  mixins: [commonMixinByTooltip],
  data() {
    return {
      isShowTooltip: false,
      classStr: tool.randomNumber().replace(/[0-9]+/g, ""),
      customId: tool.randomNumber(),
    };
  },
};
</script>

<style lang="scss" scoped>
.overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>

<style lang="scss">
.custom_popper_class {
  max-width: auto !important;
}
</style>